import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { allowedTagsDefault } from '@Services/HtmlSanitizeService';
import useParseMaintainMessage from '@Containers/InProductMessages/MaintainMessage/useParseMaintainMessage';

import './MaintainMessage.theme.scss';

function MaintainMessage({ message }) {
  const parsedMessage = useParseMaintainMessage({ message });

  return (
    <div className="maintain-message">
      <svg className="maintain-message__icon">
        <use xlinkHref="#icon-alert" />
      </svg>
      <InnerHTML
        tag="span"
        className="maintain-message__text"
        html={parsedMessage}
        mode="escape"
        allowedTags={allowedTagsDefault.concat('a')}
        allowedAttributes={['href', 'target']}
      />
    </div>
  );
}

MaintainMessage.propTypes = {
  message: PropTypes.string,
};

export default MaintainMessage;
